// extracted by mini-css-extract-plugin
export default {"map":"Map_map__Mu47v","map__container":"Map_map__container__nIKWk","map__text":"Map_map__text__e-yTG"};